import { render, staticRenderFns } from "./ProductRating.vue?vue&type=template&id=a61a67d8"
import script from "./ProductRating.vue?vue&type=script&lang=js"
export * from "./ProductRating.vue?vue&type=script&lang=js"
import style0 from "./ProductRating.vue?vue&type=style&index=0&id=a61a67d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports